export * from './BlazeMaterial';
export { default as LineClearEffect } from './effects/EmberLineClearEffect';
export { default as TetrisFinisher } from './effects/EmberTetrisFinisher';
export { default as HardDropTrail } from './effects/EmberHardDropTrail';
export { default as BlockPlaceEffect } from './effects/EmberBlockPlaceEffect';
export { default as Block3D } from './EmberBlock3D';
export { default as BoardGrid3D } from './EmberBoardGrid3D';

// Re-export theme config
export { THEME_CONFIG } from './BlazeMaterial';

// Default export with all theme components
const BlazeTheme = {
  name: 'Blaze',
  getBlockColor: require('./BlazeMaterial').getBlockColor,
  getEmissiveColor: require('./BlazeMaterial').getEmissiveColor,
  COLORS: require('./BlazeMaterial').FIRE_COLORS,
  TETROMINO_COLORS: require('./BlazeMaterial').FIRE_TETROMINO_COLORS,
  config: require('./BlazeMaterial').THEME_CONFIG,
  Block3D: require('./EmberBlock3D').default,
  BoardGrid3D: require('./EmberBoardGrid3D').default,
  effects: {
    LineClearEffect: require('./effects/EmberLineClearEffect').default,
    TetrisFinisher: require('./effects/EmberTetrisFinisher').default,
    HardDropTrail: require('./effects/EmberHardDropTrail').default,
    BlockPlaceEffect: require('./effects/EmberBlockPlaceEffect').default,
  },
};

export default BlazeTheme;
